import { Tabs } from "@mui/material";
import { DashboardTab } from "api/queries/useGetDashboard";
import layout from "common/layoutDefinitions";
import { withErrorBoundary } from "utils/ErrorBoundary";
import Tab from "./Tab";

interface Props {
	tabs: DashboardTab[];
	currentTabIndex: number;
	isOverflowComponent?: boolean;
}

const NavTabs = ({
	tabs,
	currentTabIndex: tabIndex,
	isOverflowComponent = false,
}: Props) => {
	const isValidTabIndex = tabIndex >= 0 && tabIndex < tabs.length;
	return (
		<Tabs
			TabIndicatorProps={tabIndicatorProps}
			orientation={isOverflowComponent ? "vertical" : "horizontal"}
			sx={tabContainerSx(isOverflowComponent)}
			value={isValidTabIndex ? tabIndex : false}
		>
			{tabs.map((tab, index) => (
				<Tab
					isCurrentTab={tabIndex === index}
					isOverflowComponent={isOverflowComponent}
					key={tab.key}
					tab={tab}
				/>
			))}
		</Tabs>
	);
};

export default withErrorBoundary(NavTabs);

/** Styles */

const tabContainerSx = (isOverflowComponent: boolean) => ({
	"& .MuiTabs-flexContainer": {
		alignItems: "flex-end",
		height: isOverflowComponent ? "fit-content" : "60px",
	},
	marginBottom: isOverflowComponent ? 0 : `-${layout.navBar.border}px`,
});

const tabIndicatorProps = {
	style: { display: "none" },
};
